.tileViewContainer {
  flex: 1;

  .tileView {
    background-color: #fafafa;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 72px 54px;
  }

  .issueTile {
    height: 342px;
    margin: 0 18px;
    margin-bottom: 72px;
    text-align: center;
    width: 180px;

    button {
      background: transparent;
      border: 0;
    }

    img {
      box-shadow: 0px 3px 12px 0px rgb(0, 0, 0, 0.15);
      margin-bottom: 12px;
      width: 180px;
    }

    .tileDay {
      color: #464646;
      font-family: var(--brand-button-font-family);
      font-size: 14px;
      margin-bottom: 4px;
    }

    .tileDate {
      color: #6f6f6f;
      font-family: var(--brand-button-font-family);
      font-size: 12px;
    }
  }
}

@media screen and (max-height: 1050px) {
  .tileViewContainer {
    .issueTile {
      margin-bottom: 30px;
    }
  }
}

@media screen and (max-width: 1050px) {
  .tileViewContainer .tileView {
    padding: 36px 26px;
  }
}

@media screen and (max-width: 500px) {
  .tileViewContainer {
    .tileView {
      padding: 36px 18px;
    }

    .issueTile {
      width: calc((100% - 108px) / 2);
      max-height: fit-content;
      margin: 0 0 30px 0;
      padding: 0 18px;
      img {
        max-width: 132px;
        margin: auto;
        margin-bottom: 12px;
        width: 100% !important;
      }
    }
  }
}

@media screen and (max-width: 676px) {
  .tileViewContainer .tileView {
    justify-content: center;
  }
}
